import { mergeObject } from '@domgen/dgx-fe-common';
import { AppConfig } from '../../models/config/app-config.type';
import { mockDomainConfig } from '@domgen/dgx-fe-config';
import { mockAppEnvironment } from '../environment/app-environment.mock';
import { mockAppRuntimeConfig } from '../runtime/app-runtime-config.mock';

export const mockAppConfig: AppConfig = {
  ...mergeObject(mockAppEnvironment, mockAppRuntimeConfig, mockDomainConfig),
};
